import React from "react"
import DataTable from "ui/DataTable"
import PropTypes from "prop-types"
import { crewMembersColumns } from "./columns"

// Example data, replace with your real data source
export const dataSource = [
            {
            key: 1,
            image: "https://randomuser.me/api/portraits/men/32.jpg",
            name: "Alex White",
            title: "Senior Captain",
            role: "Captain",
            phone: "(239) 555-0108",
            assignedExperiences: 5,
            upcomingBookings: 10,
            availability: "10:00 AM - 4:00 PM",
            nextTimeOff: "09/17/2025"
        },
        {
            key: 2,
            image: "https://randomuser.me/api/portraits/women/44.jpg",
            name: "Leslie Alexander",
            title: "Adventure Guide",
            role: "Guide",
            phone: "(239) 555-0108",
            assignedExperiences: 2,
            upcomingBookings: 14,
            availability: "10:00 AM - 4:00 PM",
            nextTimeOff: "10/01/2025"
        },
        {
            key: 3,
            image: "https://randomuser.me/api/portraits/men/65.jpg",
            name: "John Wilson",
            title: "Lifeguard",
            role: "Crew Member",
            phone: "(239) 555-0108",
            assignedExperiences: 5,
            upcomingBookings: 0,
            availability: "Time off till 4:00 PM",
            nextTimeOff: "09/16/2025"
        },
        {
            key: 4,
            image: "https://randomuser.me/api/portraits/women/68.jpg",
            name: "Leslie Alexander",
            title: "Engineer",
            role: "Crew Member",
            phone: "(239) 555-0108",
            assignedExperiences: 1,
            upcomingBookings: 0,
            availability: "Day off",
            nextTimeOff: "-"
        },
        {
            key: 5,
            image: "https://randomuser.me/api/portraits/women/69.jpg",
            name: "Leslie Alexander",
            title: "Engineer",
            role: "Crew Member",
            phone: "(239) 555-0108",
            assignedExperiences: "Assign",
            upcomingBookings: 10,
            availability: "10:00 AM - 4:00 PM",
            nextTimeOff: "09/24/2025"
        },
         {
            key: 6,
            image: "https://randomuser.me/api/portraits/women/69.jpg",
            name: "Leslie Alexander",
            title: "Engineer",
            role: "Crew Member",
            phone: "(239) 555-0108",
            assignedExperiences: "Assign",
            upcomingBookings: 10,
            availability: "10:00 AM - 4:00 PM",
            nextTimeOff: "09/24/2025"
        },
         {
            key: 7,
            image: "https://randomuser.me/api/portraits/women/69.jpg",
            name: "Leslie Alexander",
            title: "Engineer",
            role: "Crew Member",
            phone: "(239) 555-0108",
            assignedExperiences: "Assign",
            upcomingBookings: 10,
            availability: "10:00 AM - 4:00 PM",
            nextTimeOff: "09/24/2025"
        },
         {
            key: 8,
            image: "https://randomuser.me/api/portraits/women/69.jpg",
            name: "Leslie Alexander",
            title: "Engineer",
            role: "Crew Member",
            phone: "(239) 555-0108",
            assignedExperiences: "Assign",
            upcomingBookings: 10,
            availability: "10:00 AM - 4:00 PM",
            nextTimeOff: "09/24/2025"
        },
         {
            key: 9,
            image: "https://randomuser.me/api/portraits/women/69.jpg",
            name: "Leslie Alexander",
            title: "Engineer",
            role: "Crew Member",
            phone: "(239) 555-0108",
            assignedExperiences: "Assign",
            upcomingBookings: 10,
            availability: "10:00 AM - 4:00 PM",
            nextTimeOff: "09/24/2025"
        },
         {
            key: 10,
            image: "https://randomuser.me/api/portraits/women/69.jpg",
            name: "Leslie Alexander",
            title: "Engineer",
            role: "Crew Member",
            phone: "(239) 555-0108",
            assignedExperiences: "Assign",
            upcomingBookings: 10,
            availability: "10:00 AM - 4:00 PM",
            nextTimeOff: "09/24/2025"
        },
         {
            key: 11,
            image: "https://randomuser.me/api/portraits/women/69.jpg",
            name: "Leslie Alexander",
            title: "Engineer",
            role: "Crew Member",
            phone: "(239) 555-0108",
            assignedExperiences: "Assign",
            upcomingBookings: 10,
            availability: "10:00 AM - 4:00 PM",
            nextTimeOff: "09/24/2025"
        }

    ]


const CrewMembersTable = ({ data = dataSource, onChange }) => {
  return <DataTable columns={crewMembersColumns} dataSource={data} pagination={false} onChange={onChange} />
}

CrewMembersTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  onChange: PropTypes.func
}

export { crewMembersColumns as columns }
export default React.memo(CrewMembersTable)
